<template>
  <div>
    <ScrollTopComponent :isScrollToTop="true" class="z-index-1001" v-if="this.$store.getters.activitiesSelectedList.length === 0 && createItinerary">
      <a
      class="btn-scroll-to-top-itinerari-predefiniti "

      >
      <i class="bi bi-arrow-up arrow"></i>
      </a>
    </ScrollTopComponent>
    <ScrollTopComponent :isScrollToTop="true" class="z-index-1001" v-if="this.$store.getters.activitiesSelectedList.length > 0 && createItinerary">
      <a
        :class="
          isLarge
              ? 'btn-scroll-to-top-large'
              : 'btn-scroll-to-top'
        "
      >
        <i class="bi bi-arrow-up arrow"></i>
      </a>
    </ScrollTopComponent>

    <ScrollTopComponent :isScrollToTop="true" class="z-index-1001" v-if="!createItinerary">
      <a
        class="btn-scroll-to-top-itinerari-predefiniti"
    
      >
        <i class="bi bi-arrow-up arrow"></i>
      </a>
    </ScrollTopComponent>
    <ScrollTopComponent
      v-if="createItinerary"
      class="z-index-1001"
      :isScrollToTop="false"
      v-on:create-itinerary="catchCreateItinerary()"
    >
      <span
        :class="isLarge ? 'btn-create-itinerary-large' : 'btn-create-itinerary'"
      >
        <svg height="80" width="80">
          <text
            x="10"
            y="20"
            style="font-weight: bold"
            :style="isLarge ? ' font-size: 18px' : ''"
          >
            <tspan x="22" y="45">Crea</tspan>
            <tspan :x="isLarge ? '4' : '6'" y="68">Itinerario</tspan>
          </text>
        </svg>
      </span>
    </ScrollTopComponent>
  </div>
</template>

<script>
import ScrollTopComponent from "./ScrollTopComponent";
import $ from "jquery";

export default {
  props: {
    createItinerary: Boolean,
  },
  components: {
    ScrollTopComponent,
  },
  data() {
    return {
      windowWidth: 0,
    };
  },
  methods: {
    catchCreateItinerary() {
      this.$emit("create-itinerary");
    },
  },

  computed: {
    isLarge() {
      return this.windowWidth >= 768;
    },
  },

  mounted() {
    this.windowWidth = $(window).width();

    $(window).resize(() => {
      this.windowWidth = $(window).width();
    });
  },
};
</script>

<style lang="scss" scoped>
.z-index-1001 {
  z-index: 1001;
}
</style>
